import { Link } from 'react-router-dom';
import { ArrowRight, Play } from 'lucide-react';

export default function DarkPanSection() {
  return (
    <section id="dark-pan" className="bg-[#0A0605] px-5 py-16 text-[#F3EAD3] md:py-24">
      <div className="mx-auto max-w-4xl">
        <p className="mb-3 text-xs font-semibold tracking-[0.28em] uppercase text-[#C9A227]">WTFairytale · The Dark Pan</p>
        <h2 className="mb-4 font-serif text-4xl leading-tight md:text-5xl">Some songs don't take you to Neverland.</h2>
        <p className="mb-8 max-w-2xl text-base text-[#B7A99A] md:text-lg">
          Neverland isn't a place you fly to. It's a job site you're sold on. Second star to the right is a night shift.
        </p>
        
        {/* Trailer - The ONLY video on the homepage */}
        <div className="mb-8">
          <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: 12, background: '#000' }}>
            <iframe 
              src="https://www.youtube.com/embed/GFvxleKnwJY?rel=0" 
              title="The Dark Pan - Official Trailer" 
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }} 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowFullScreen 
              data-testid="dark-pan-trailer"
            />
          </div>
          <p className="mt-3 text-sm text-[#B7A99A]/80">
            <a href="https://youtu.be/GFvxleKnwJY" target="_blank" rel="noopener noreferrer" className="text-[#C9A227] hover:underline">Watch on YouTube</a>
          </p>
        </div>

        <Link 
          to="/dark-pan" 
          className="inline-flex items-center gap-2 px-8 py-4 bg-[#C9A227] text-[#0A0605] font-semibold rounded-lg hover:bg-[#d4af37] transition-all"
          data-testid="dark-pan-section-cta"
        >
          Enter The Dark Pan Experience
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}
